"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginTestUsersResponseUserTokensToJSON = exports.LoginTestUsersResponseUserTokensFromJSONTyped = exports.LoginTestUsersResponseUserTokensFromJSON = void 0;
var runtime_1 = require("../runtime");
function LoginTestUsersResponseUserTokensFromJSON(json) {
    return LoginTestUsersResponseUserTokensFromJSONTyped(json, false);
}
exports.LoginTestUsersResponseUserTokensFromJSON = LoginTestUsersResponseUserTokensFromJSON;
function LoginTestUsersResponseUserTokensFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': !(0, runtime_1.exists)(json, 'userId') ? undefined : json['userId'],
        'authToken': !(0, runtime_1.exists)(json, 'authToken') ? undefined : json['authToken'],
    };
}
exports.LoginTestUsersResponseUserTokensFromJSONTyped = LoginTestUsersResponseUserTokensFromJSONTyped;
function LoginTestUsersResponseUserTokensToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userId': value.userId,
        'authToken': value.authToken,
    };
}
exports.LoginTestUsersResponseUserTokensToJSON = LoginTestUsersResponseUserTokensToJSON;
